// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dkpJ","toggleWrap":"styles_toggleWrap__PJJqL","content":"styles_content__14PQL","selectAreaCode":"styles_selectAreaCode__2m7nm"};